import { render, staticRenderFns } from "./DialogRoomMerge.vue?vue&type=template&id=4ec2de5e&scoped=true&"
import script from "./DialogRoomMerge.vue?vue&type=script&lang=js&"
export * from "./DialogRoomMerge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec2de5e",
  null
  
)

export default component.exports